import React, {useEffect, useState} from 'react';
import {get} from '~utils/api';
import {buildImageUrl} from '~utils/helper';
import messageIcon from '~images/message-icon.svg';
import closeIcon from '~images/close-outlined.svg';

import './styles.scss';

/**
 * Kiểm tra xem chuỗi URL có thể là số điện thoại hay không.
 */
const isPhoneNumber = url => {
  if (!url) return false;
  if (url.startsWith('tel:')) return true;
  const cleaned = url.replace(/[\s\-().]/g, '');
  return /^\+?\d{7,15}$/.test(cleaned);
};

/**
 * Trả về href phù hợp: tel: cho số điện thoại, giữ nguyên cho URL thường.
 */
const getHref = url => {
  if (!isPhoneNumber(url)) return url;
  if (url.startsWith('tel:')) return url;
  return `tel:${url.replace(/[\s\-().]/g, '')}`;
};

const SocialMediaSidebar = () => {
  const [socialMedias, setSocialMedias] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const fetchSocialMedias = async () => {
      try {
        const res = await get('/v1/social-media');
        if (res) {
          const data = Array.isArray(res) ? res : res.items || [];
          setSocialMedias(data.filter(item => item.isActive));
        }
      } catch (err) {
        console.error('Failed to fetch social medias:', err);
      }
    };
    fetchSocialMedias();
  }, []);

  if (!socialMedias.length) return null;

  const renderLink = item => {
    const phone = isPhoneNumber(item.url);
    return (
      <a
        key={item.id}
        href={getHref(item.url)}
        {...(!phone && {target: '_blank', rel: 'noopener noreferrer'})}
        className='social-media-item'
        title={item.name}
      >
        <img src={buildImageUrl(item.icon, '64x64')} alt={item.name} className='social-media-icon' />
      </a>
    );
  };

  return (
    <div className={`social-media-sidebar${isOpen ? ' is-open' : ''}`}>
      <div className='social-media-list'>{socialMedias.map(renderLink)}</div>
      <button
        type='button'
        className='social-media-trigger'
        aria-expanded={isOpen}
        aria-label={isOpen ? 'Đóng liên hệ' : 'Mở liên hệ'}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span className='social-media-trigger-icon'>
          <img
            src={isOpen ? closeIcon : messageIcon}
            alt=''
            className={isOpen ? 'social-media-close-icon' : 'social-media-message-icon'}
            aria-hidden
          />
        </span>
        <span className='trigger-text'>Liên hệ</span>
      </button>
    </div>
  );
};

export default SocialMediaSidebar;
